import React, { useState, useCallback, useEffect } from "react";
import { Card, Table, Button, Input, Tabs, Popconfirm, Pagination, message } from "antd";
import Service from "../../services/content";
import { ContentKeysColumns } from "../../misc/tableColumnConfig";
import ModalForm from "./modalForm";

const Content = () => {

  const [formRef, setFormRef] = useState(null);
  const [visible, setVisible] = useState(false);

  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(100);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [showFilters, setShowFilters] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [search_text, setSearch_text] = useState(undefined);

  const [selectedAdId, setSelectedAdId] = useState("");
  const [selectedData, setSelectedData] = useState({});
  const [pageType, setPageType] = useState();
  const [country, setCountry] = useState();

  useEffect(() => {
    getContentKeys();
  }, [])

  const formatData = (page, index) => {
    return {
      key: page?._id,
      stringId: page?.stringId,
      value: page?.value,
      actionButtons: <div className="action-btn" style={{ width: '80px' }}>
        <a
          title="Edit"
          className="pencilIcon"
          onClick={() => {
            setVisible(true);
            setSelectedAdId(page._id);
            setSelectedData(page);
          }}
        >
          <i class="fa fa-pencil"></i>
        </a>
        <a href="" title="Delete">
          <Popconfirm
            title="Are you sure delete this ?"
            onConfirm={async (e) => {
              const response = await Service.deleteContentKeys(page?._id);

              if (response.message === "contentKeys.ContentKeysDeleted") {
                message.success('Deleted!');
                getContentKeys();
              } else {
                message.error('An unexpected error has occured while deleting record!');
              }

            }}
            onCancel={() => { }}
            okText="Yes"
            cancelText="No"
          >
            <span className="gx-link" title="Delete">
              <i class="icon icon-trash"></i>
            </span>
          </Popconfirm>
        </a>
      </div>
    }
  }

  const getContentKeys = async () => {
    setLoading(true);

    const response = await Service.getContentKeys({
      pageSize,
      pageIndex,
      searchTerm: search_text
    }).catch((e) => {
      message.error('Something went wrong!');
      setLoading(false);
    });

    if (response?.status === 200) {
      const data = response?.data?.pages?.length > 0 && response?.data?.pages?.map(formatData);

      setData(data);
      setTotalPages(response?.data?.total || 100);
    }

    setLoading(false);
  }

  const onPageChange = (page) => {
    setLoading(true);
    setPageIndex(page - 1);
    setCurrentPage(page);

    getContentKeys();
  }

  const onSearch = () => onSearchPress();

  const onSearchChange = (e) => setSearch_text(e.target.value);

  const onSearchPress = () => {
    setLoading(true);
    setData([]);
    setTotalPages(100);
    setPageIndex(0);
    setCurrentPage(1);

    getContentKeys();
  }

  const onClear = () => {
    setLoading(false);
    setData([]);
    setTotalPages(100);
    setPageIndex(0);
    setPageSize(100);
    setCurrentPage(1);
    setSearch_text(undefined);

    setPageType(undefined);
    setCountry(undefined);

    getContentKeys();
  }

  const handleCancel = () => {
    setLoading(false);
    setVisible(false);
    formRef.resetFields();
  }

  const handleSubmit = () => {
    setLoading(true);

    formRef.validateFields(async (err, values) => {
      if (err) {
        setLoading(false);
        return;
      }

      console.log("Received values of form: ", values);

      if (!selectedAdId) {
        const response = await Service.addContentKeys(values);

        if (response?.status === 200) {
          message.success('Added');
          formRef.resetFields();
          setLoading(false);
          setVisible(false);
          getContentKeys();
        } else {
          message.error('Something went wrong');
          setLoading(false);
        }
      } else {
        const response = await Service.updateContentKeys({
          contentKeysId: selectedAdId,
          stringId: values.stringId,
          value: values.value
        });

        if (response?.status === 200) {
          message.success('Updated');

          formRef.resetFields();
          setLoading(false);
          setVisible(false);
          getContentKeys();
          setSelectedAdId("");
        } else {
          message.error('Something went wrong');
          setLoading(false);
        }
      }

    })
  }

  const saveFormRef = useCallback(node => {
    if (node !== null) {
      setFormRef(node);
    }
  }, []);

  const { Search } = Input;

  return (
    <>
      <ModalForm
        ref={saveFormRef}
        visible={visible}
        loading={loading}
        data={selectedData}
        //onOk={this.handleOk}
        onCancel={handleCancel}
        onCreate={handleSubmit}
      />
      <div className="menu-editor-box card-pad-new menu-cate-list users-main-page">
        <div className="payout-report-box">
          <Card className="gx-card breadcrumb-box" title="">

            <div className="ant-row hd-title">
              <div className="ant-col-md-12">
                <h1>Content Keys</h1>
              </div>
              <div className="ant-col-md-12 rite-btn">
                <Button
                  type="primary"
                  className="color-white"
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  <i class="icon icon-add"></i> Add
                </Button>
              </div>
            </div>

            <div className="ant-row gx-mt-4">
              <div className="ant-col-md-12" style={{ paddingTop: 15 }}>
              </div>
              <div className="ant-col-md-12 rite-btn ">
                <div className="search-box">
                  <Search
                    placeholder="search"
                    style={{ width: 200 }}
                    onSearch={onSearch}
                    onChange={onSearchChange}
                    value={search_text}
                  />
                </div>
                <Button className="my-btn-cust" onClick={onClear}>
                  Clear
                </Button>
              </div>
            </div>

            <div className="collaps-main gx-mt-4">
              <div className="ant-row">
                <div className="ant-col gx-order-sm-1 ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24">

                  <Table
                    rowKey={(record) => {
                      return record?.key;
                    }}
                    pagination={{ pageSize: 100 }}
                    className="gx-table-responsive payout-report menu-cate-lisi-table sellLog-mn"
                    columns={ContentKeysColumns}
                    loading={loading}
                    dataSource={data}
                  >
                    <Tabs className="tabs-main-box gx-mt-4" type="card">
                      <div className="ant-col-md-24 rite-btn ">
                        <div className="search-box">
                          <Search
                            placeholder="search"
                            style={{ width: 200 }}
                            value={search_text}
                            onSearch={onSearch}
                            onChange={onSearchChange}
                          />
                        </div>
                        <Button
                          className="my-btn-cust"
                          onClick={async (e) => { }}
                        >
                          Clear
                        </Button>
                        <a
                          className="my-btn-link more-link"
                          onClick={() => { }}
                        >
                          More
                          <i class="icon icon-chevron-down"></i>
                        </a>
                        <Button
                          disabled
                          className="my-btn-cust"
                          onClick={() => { }}
                        >
                          <i class="icon icon-add"></i> Add
                        </Button>
                      </div>
                    </Tabs>
                  </Table>

                  <div className="pageing-box gx-mt-4">
                    <Pagination
                      simple
                      pageSize={100}
                      defaultCurrent={1}
                      total={totalPages}
                      onChange={onPageChange}
                      current={currentPage}
                    />
                  </div>

                </div>
              </div>
            </div>

          </Card>
        </div>
      </div >
    </>
  );
}

export default Content;